module.exports = __webpack_public_path__ + "img/face-tongue-money.ae9aa660.svg";